export const DASHBOARD = 'Dashboard'
export const CITATIONS = 'Citations'
export const PAPERS = 'Papers'
export const GUIDES = 'Guides'
export const PLAGIARISM = 'Plagiarism'
export const SIGN_IN = 'Sign in'
export const SIGN_UP = 'Sign up'
export const UPGRADE = 'Upgrade'
export const WRITING_ASSISTANT = 'Writing Assistant'
